import Cookies from 'universal-cookie';
import { getCookieDomain } from '@ifixit/helpers';
import { CookieUtils } from 'Shared/cookies/cookie-utils';

const FEATURE_OVERRIDES_COOKIE = 'featureOverrides';
const MEDIA_MANAGER_V2_FLAG = 'media-manager-v2';
const SEVEN_DAYS_IN_SECONDS = 7 * 24 * 60 * 60;

function readFeatureOverrides(): Record<string, unknown> {
   const value = new Cookies().get(FEATURE_OVERRIDES_COOKIE);
   if (!value) {
      return {};
   }
   // universal-cookie parses JSON automatically, but fall back for a raw string.
   if (typeof value === 'object') {
      return value as Record<string, unknown>;
   }
   try {
      return JSON.parse(value);
   } catch {
      return {};
   }
}

/**
 * Force this browser onto the chosen Media Manager version by writing the
 * `media-manager-v2` GrowthBook override into the same `featureOverrides`
 * cookie the dev toolbar uses, then reloading so the server re-resolves the
 * flag. Other overrides already in the cookie are preserved.
 *
 * Only employees/dev can actually flip this -- the server strips the override
 * for anyone else -- so callers gate the switch affordance on that eligibility
 * (`isRestrictedForCurrentUser()` server-side).
 */
export function switchMediaManagerVersion(useV2: boolean): void {
   const overrides = { ...readFeatureOverrides(), [MEDIA_MANAGER_V2_FLAG]: useV2 };
   CookieUtils.set(FEATURE_OVERRIDES_COOKIE, JSON.stringify(overrides), {
      domain: getCookieDomain(window.location),
      maxAgeInSeconds: SEVEN_DAYS_IN_SECONDS,
   });
   window.location.reload();
}
